import { useSaveBulkExportStateMutation } from "../../api/mutations/saveBulkExportState";
import { FavouriteItemType } from "../../../favourites/types";
import { useBulkExportSettingsSave } from "../../shared/hooks/useBulkExportSettingsSave";
import { virtualConfiguration, virtualFrequency } from "../BulkExportStepper/BulkExportStepper.constants";

export interface ISaveExportSettingsParams {
  name?: string;
  id?: number;
  parentId?: number;
  favouriteId?: number;
  type: FavouriteItemType.BulkExport;
}

export function useSaveAsSettingsButton() {
  const { saveBulkExportSettings } = useSaveBulkExportStateMutation();
  const settings = useBulkExportSettingsSave();

  if (!settings) {
    return null;
  }

  const format = settings?.format!;
  const cubeId = settings?.cubeId;
  const dimensions = settings?.dimensions
    .filter((dim) => dim.id !== "value")
    .filter((dim) => dim.id !== "source")
    .filter((dim) => dim.id !== "value_trade")
    .filter((dim) => dim.id !== virtualFrequency.hierarchyIdentifier)
    .filter((dim) => dim.id !== virtualConfiguration.identifier);
  const measures = settings?.measures;

  const saveExportSettings = (name: string) => {
    saveBulkExportSettings({
      format,
      cubeId,
      name,
      dimensions,
      measures,
    });
  };
  return { saveExportSettings };
}
